<!--주소검색 팝업 -->
<template>
  <div>
    <modal v-if="isModalShow" @close="closed">
      <template slot="header">
        <h4 class="modal-title">주 소 조 회</h4>
        <md-button
          class="md-simple md-just-icon md-round modal-default-button"
          @click="closed"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <template slot="body">
        <div id="app">
          <DaumPostcode :on-complete="handleAddress" script-url="https://t1.kakaocdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js" />
        </div>
      </template>

      <template slot="footer">
        <md-button class="md-danger md-simple" @click="closed">
          Close
        </md-button>
      </template>
    </modal>
  </div>
</template>

<script>

import DaumPostcode from "vuejs-daum-postcode";
import { Modal } from "@/components";

export default {
  name: "PostcodePopComp",
  props: {
    isShow : {
      type: Boolean,
      default: false
    }
  },
  components: {
    Modal,
    DaumPostcode
  },


  created() {
    console.log('[주소팝업] PostcodePopComp created, isShow:', this.isShow);
  },
  mounted() {
    console.log('[주소팝업] PostcodePopComp mounted, isShow:', this.isShow);
  },

  computed: {
    isModalShow: function(){
      return this.isShow;
    }
  },
  data() {
    return {
    };
  },

  methods: {
    closed(){
      this.$emit('update:isShow', false);
    },
    handleAddress(data){
      this.$emit('returnResult', data);
    },
    logRender() {
      console.log('[주소팝업] PostcodePopComp template render, isShow:', this.isShow);
      return true;
    }
  }
}
</script>

<style lang="css">

</style>